module.exports = function() {

  var lh = "";
  lh = location.href;

  if (lh.match(/dcmsadm/)){
  } else {


  	if(location.pathname == "/" || location.pathname == "/index.html"){
  		$('nav ul li#globalnav01').addClass('main_current');
  		$("#locator").remove();
  	}else{
  		var now = location.href.split('/');
  		var endDir = now.slice(now.length-1,now.length-0);
  		var endDir2 = now.slice(3,4);
  		//$('#globalnav ul li a[href$="'+endDir+'/"]').parent().addClass('main_current');
  		$('nav ul li a[href$="'+endDir+'"]').parent().addClass('main_current');
  		$('nav ul li a[href$="'+endDir2+'.html"]').parent().addClass('main_current');

  		$('body').addClass("common");

  	};

  }

}



//////////////////
// WEBPACK FOOTER
// ./dev/dcms_media/js/components/module/current.js
// module id = 18
// module chunks = 0